// Chat Data Model
export const chatModel = {
  // Chat Collection Structure
  collection: 'chats',
  
  // Messages Collection Structure
  messagesCollection: 'messages',
  
  // Default Chat Document Structure
  defaultChat: {
    id: '', // Auto-generated by Firestore
    type: '', // order, product_inquiry
    participants: [], // Array of user IDs
    orderId: '', // For order chats
    productId: '', // For product inquiry chats
    storeId: '', // For product inquiry chats
    lastMessage: '', // Last message text
    lastMessageAt: null, // Timestamp of last message
    lastMessageBy: '', // User ID who sent last message
    unreadCount: {}, // { userId: count }
    
    // Metadata
    createdAt: '', // ISO string
    updatedAt: '' // ISO string
  },
  
  // Default Message Document Structure
  defaultMessage: {
    id: '', // Auto-generated by Firestore
    chatId: '', // Reference to chat
    senderId: '', // User who sent the message
    senderName: '', // Sender's display name
    text: '', // Message text
    read: false, // Whether message has been read
    readAt: null, // When message was read
    
    // Metadata
    createdAt: '', // ISO string
    updatedAt: '' // ISO string
  },
  
  // Chat Types
  types: {
    ORDER: 'order', // แชทในออเดอร์
    PRODUCT_INQUIRY: 'product_inquiry' // แชทสอบถามสินค้า
  },
  
  // Create chat helper
  createChat: (type, participants, orderId = null, productId = null, storeId = null) => {
    return {
      ...chatModel.defaultChat,
      type,
      participants,
      orderId,
      productId,
      storeId,
      unreadCount: participants.reduce((acc, userId) => {
        acc[userId] = 0;
        return acc;
      }, {}),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
  },
  
  // Create message helper
  createMessage: (chatId, senderId, senderName, text) => {
    return {
      ...chatModel.defaultMessage,
      chatId,
      senderId,
      senderName,
      text,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
  }
};

export default chatModel;













